import cn from 'classnames';
import Image from 'next/image';
import React from 'react';

import s from 'components/pagesComponents/payments/PlansPage/PlansPage.module.scss';

export default function WelltoryProLogo(): JSX.Element {
  return (
    <div className={cn(s.proLogo, 'mb-5')}>
      <Image
        width={188}
        height={88}
        src="/pagesImages/premium-features/logo.png"
      />
    </div>
  );
}
